import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { Alert, Divider, Space, Image } from 'antd';
import { FC } from "react";


const Accueil: FC = () => {

    return (
            <div>
                <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: "16px" }}>
                    <Alert message={<span style={{ fontSize: 16, fontWeight: 700 }}>Mode de pêche</span>}
                        description={
                            <ul>
                                <li>4 cannes MAXIMUM par poste</li>
                                <li>La pêche se pratique uniquement sur le poste de pêche choisi à la réservation</li>
                                <li>Le matériel doit être adapté à la pêche de la carpe en batterie et en no kill</li>
                                <li>Les montages doivent prévoir de libérer le plomb en cas de casse</li>
                                <li>Hameçon N°4 maximum et sans ardillon</li>
                                <li>Seul sont autorisés les appâts d'origines végétales, pellet ou plastique</li>
                                <li>
                                    Les poissons doivent être manipulés avec précaution, au-dessus du tapis de réception.
                                    Celui-ci devra être mouillé avant de déposer le poisson dessus.
                                </li>
                                <li>Tout poisson doit être remis à l'eau dans les meilleures conditions</li>
                                <li>Pour l'amorçage, les graines doivent avoir été trempées et bien cuites.</li>
                                <li>A partir de 22 heures, jusqu'à 8 heures, éviter tous bruits (musique, conversation endiablée, déplacement de véhicule, baisser le son de vos détecteurs etc.)</li>
                            </ul>
                        }
                        type="info"
                        showIcon
                    />
                    <Alert message={<span style={{ fontSize: 16, fontWeight: 700 }}>Adhésion supplémentaire pour la pêche de nuit</span>}
                        description={
                            <p>
                                <strong>Supplément à l'adhésion annuelle pour une pêche de nuit lors d'une session par 24h (arrivée 13H départ 12H)
                                par poste dans le grand étang, prix 20€.</strong><br />
                                Tout pêcheur devra être en possession de l'adhésion anuelle à prendre au PMU de Oye Plage "le temple
                                d'Ourasi" avenue Paul Machy. <br />
                                Les réservations pour la pêche de nuit dans le grand étang se feront uniquement sur ce site<br />
                                Le paiement de vos réservations sera encaissé par un de nos gardes assermentés ou un membre du bureau.<br />
                                <br />
                                Merci de prévoir la somme exacte à payer 20€ par 24H
                            </p>
                        }
                        type="info"
                        showIcon
                    />

                    <Alert
                        message={<span style={{ fontSize: 16, fontWeight: 700 }}>Obligation</span>}
                        description={
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                <li><strong>avoir un WC portable</strong></li>
                                <li>Les pêcheurs doivent ramener leurs déchets chez eux</li> 
                                <li>De respecter le règlement général affiché sur le chalet à l'entrée du petit étang ou <a href="https://www.facebook.com/p/Les-%C3%A9tangs-communaux-de-Oye-Plage-100047316354194/"> sur notre page FaceBook (Les étangs communaux de Oye-Plage)</a>
                                </li>
                                <li>
                                    Le non-respect du règlement ou poste rendu sale entrainerai un blocage ou une expulsion de l'association immédiate
                                </li>
                                <li>
                                    Seul le véhicule du pêcheur est autorisé sur le poste
                                </li>
                                <li>
                                    Le code de la barrière ??? Vous sera communiqué la veille de votre session ou envoyez un message à Guy : 06.15.74.34.53 au jour de la réservation
                                </li>
                                <li><span style={{textDecoration: "underline"}}>Désinfectant pour les poissons blessés</span></li>
                                <li>Respecter les lieux (vous êtes sur un site naturel protégé), les autres pêcheurs, les promeneurs et les gardes pêche</li>
                                <li>Rouler au pas (20 km/h max). Eviter les allées et venues</li>
                                <li>Les jeunes de moins de 18 ans doivent être accompagnés d'un adulte <span style={{textDecoration: "underline"}}>présent</span></li>
                            </ul>
                        }
                        type="info"
                        showIcon
                        icon={<CheckCircleOutlined />}
                    />
                    <Alert
                        message={<span style={{ fontSize: 16, fontWeight: 700 }}>Il est interdit</span>}
                        description={
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                <li>D'utiliser le magic TWIG, d'utiliser des drones amorceurs</li>
                                <li>De pêcher d'autres espèces que la carpe, amour blanc, silure et l'esturgeon</li>
                                <li>Toute embarcation nautique</li>
                                <li>Tresse en corps de ligne</li>
                                <li><span style={{textDecoration: "underline"}}>Sac de conservation</span></li>
                                <li>Tapis de réception plat</li>
                                <li>Utiliser de l'arachide</li>
                                <li>Rentrer dans l'eau au-dessus des genoux</li>
                                <li>Autres véhicules que celui du pêcheur sur le poste (famille, amis, autres). Le stationnement se fera sur le parking</li>
                                <li>De faire du feu au sol</li>
                                <li>Usage de l'épuisette pour les esturgeons et les silures</li>
                                <li>De déplacer les piquets servant à accrocher la chaîne</li>
                                <li>Tente de couleur autre que vert foncé</li>
                                <li>Caravane</li>
                            </ul>
                        }
                        type="error"
                        showIcon
                        icon={<StopOutlined />}
                    />
                    <Alert
                        message={<span style={{ fontSize: 16, fontWeight: 700 }}>Il est autorisé</span>}
                        description={
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                <li>Bateau amorceur dans le grand étang. (Respecter votre zone de pêche)</li>
                                <li> De prendre son camping-car dans le grand étang à partir d'une session de 24h.</li>
                                <li>Barbecue sur pied (les cendres froides à jeter dans votre poubelle)</li>
                                <li>Pêche au ZIG : être 2 sur le poste, limitée à 2 cannes, montage adapté spécial ZIG</li>
                            </ul>
                        }
                        type="success"
                        showIcon
                    />

                    <Alert message={<span style={{ fontSize: 16, fontWeight: 700 }}>PECHEURS</span>}
                        description={
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                <li>La réservation et annulation impossible 48 heures avant la date de réservation</li>
                                <li>Le pêcheur est responsable de sa famille et de ses amis qui lui rendent visite ou qui l'accompagne</li>
                                <li>L'alcool doit être consommé avec modération et discrétion</li>
                                <li>L'association Amicale des pêcheurs Ansériens décline toutes responsabilités en cas de vol ou dégradation sur les véhicules</li>
                                <li>Il est possible de prendre une douche pour 2€ au camping : BOUSCAREL, 448 Rue du lac 62215 Oye-Plage (en sortant de l'étang, au feu prendre à droite c'est à 100m)</li>
                            </ul>
                        }
                        type="warning"
                        showIcon
                    />
                </Space>

                <Divider>Plan</Divider>
                <div style={{ textAlign: "center" }}>
                    <Image
                        style={{ maxWidth: "100%", height: "auto" }}
                        src={`${process.env.PUBLIC_URL}/PlanPeche.jpg`}
                    />
                </div>

            </div>
    )
}

export default Accueil;

